function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.3,0C3.3,0,0,3.3,0,7.3s3.3,7.3,7.3,7.3s7.3-3.3,7.3-7.3S11.3,0,7.3,0z M7.3,13.4c-3.4,0-6.1-2.7-6.1-6.1 s2.7-6.1,6.1-6.1s6.1,2.7,6.1,6.1S10.7,13.4,7.3,13.4z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.8,9.7H6.7c-0.1,0-0.1,0-0.2,0.1C6.4,9.9,6.4,9.9,6.4,10v1c0,0.1,0,0.1,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1h1.1 c0.1,0,0.1,0,0.2-0.1s0.1-0.1,0.1-0.2v-1c0-0.1,0-0.1-0.1-0.2C8,9.8,7.9,9.7,7.8,9.7z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.9,3.7C8.5,3.5,8,3.4,7.4,3.4S6.3,3.5,5.8,3.7c-0.4,0.2-0.7,0.5-1,0.9C4.6,4.9,4.5,5.3,4.5,5.7c0,0.1,0,0.1,0.1,0.2 C4.6,6,4.7,6,4.8,6h1C6,6,6.1,5.9,6.1,5.7C6.2,5,6.7,4.6,7.4,4.6c0.3,0,0.6,0.1,0.8,0.3s0.3,0.4,0.3,0.7c0,0.2-0.1,0.3-0.2,0.5 C8.1,6.3,7.9,6.5,7.6,6.8C7.3,7.1,7.1,7.4,6.9,7.7C6.7,7.9,6.6,8.2,6.5,8.6c0,0.1,0,0.2,0,0.4c0,0.1,0,0.1,0.1,0.2 c0,0,0.1,0.1,0.2,0.1h1.1c0.1,0,0.2,0,0.2-0.1C8.2,9.1,8.2,9.1,8.2,9s0-0.2,0.1-0.4c0-0.2,0.2-0.3,0.3-0.6C8.8,7.6,8.8,7.5,9,7.3 c0.4-0.4,0.6-0.7,0.8-1s0.3-0.6,0.3-1c0-0.3-0.1-0.6-0.3-0.9S9.3,3.9,8.9,3.7z"
});

var SvgQuestion = function SvgQuestion(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 14.6 14.6",
    style: {
      enableBackground: "new 0 0 14.6 14.6"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuestion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/question.2a2d2e96.svg";
export { ForwardRef as ReactComponent };